import { apiErrorName } from '@/lib/recepthor-api';
import { Button, HelperText, Modal } from '@/ui';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import './OrgModales.css';

// The owner cannot leave, because nobody would be left to hold the role.
// Every other failure gets a generic message.
function leaveFailureMessage(err) {
  if (apiErrorName(err?.body) === 'OwnerOnlyAction') {
    return 'El propietario no puede salir de la organización.';
  }
  return 'No se pudo completar la acción. Intenta nuevamente.';
}

export function LeaveOrgModal({ open, onClose, onConfirm }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // The component stays mounted between opens, so a failure from the last
  // attempt would greet the next one.
  useEffect(() => {
    if (open) setError('');
  }, [open]);

  // Closing mid-request would hide the outcome of an irreversible action.
  const close = () => {
    if (!busy) onClose?.();
  };

  async function handleConfirm() {
    setError('');
    setBusy(true);
    try {
      await onConfirm?.();
      onClose?.();
    } catch (err) {
      setError(leaveFailureMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal open={open} onClose={close} size="small">
      <Modal.Header title="Salir de la organización" onClose={close} />
      <Modal.Body>
        <p style={{ margin: '0 0 12px', lineHeight: 1.5 }}>
          Esta acción es inmediata y revoca tu acceso a la organización.
        </p>
        {error && <HelperText kind="err">{error}</HelperText>}
      </Modal.Body>
      <Modal.Foot>
        <Button variant="ghost" type="button" onClick={close} disabled={busy}>
          Cancelar
        </Button>
        <Button
          variant="danger-solid"
          type="button"
          disabled={busy}
          onClick={handleConfirm}
        >
          {busy ? 'Saliendo…' : 'Salir de la organización'}
        </Button>
      </Modal.Foot>
    </Modal>
  );
}

LeaveOrgModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

export default LeaveOrgModal;
